import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ExtensionInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ExtensionInstallModal: React.FC<ExtensionInstallModalProps> = ({
  isOpen,
  onClose
}) => {

  const handleChromeStoreInstall = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    window.open(
      'https://chromewebstore.google.com/detail/a%E5%92%96-%E4%BD%A0%E7%9A%84ai%E6%8F%90%E7%A4%BA%E8%AF%8D%E7%AE%A1%E7%90%86%E5%8A%A9%E6%89%8B/dfnchjendgchjgjalobbidcekfkbfnfa?authuser=0&hl=zh-CN',
      '_blank',
      'noopener,noreferrer'
    );
  };

  const downloadUrl = 'https://10phigkp6e5nf8us.public.blob.vercel-storage.com/AI%E5%92%96-%E4%BD%A0%E7%9A%84AI%E6%8F%90%E7%A4%BA%E8%AF%8D%E7%AE%A1%E7%90%86%E5%8A%A9%E6%89%8B-Chrome-%E5%BA%94%E7%94%A8%E5%95%86%E5%BA%97.crx.zip';

    const handleLocalDownload = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    // 安全下载.zip文件
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'AI咖-AI提示词管理助手.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // 给用户反馈
    const button = e.currentTarget as HTMLButtonElement;
    const originalText = button.innerHTML;
    button.innerHTML = '<i class="fas fa-check mr-2"></i><span>下载已开始</span>';
    button.disabled = true;
    
    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 3000);
  };





  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.2 }}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-md md:max-w-4xl w-full mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* 弹框头部 */}
            <div className="bg-gradient-to-r from-primary to-primary-dark p-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                    <i className="fas fa-puzzle-piece text-lg"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold">安装浏览器插件</h2>
                    <p className="text-blue-100 text-sm">选择您的安装方式</p>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="w-8 h-8 flex items-center justify-center text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>

                        {/* 弹框内容 */}
            <div className="p-4 md:p-6">
              {/* 左右布局容器 */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
                {/* Chrome 商店安装 - 左侧 */}
                                 <div className="border border-gray-200 dark:border-gray-700 rounded-xl p-4 md:p-6 hover:border-primary dark:hover:border-primary transition-all duration-300 hover:shadow-lg bg-gradient-to-br from-blue-50/50 to-white dark:from-blue-900/10 dark:to-gray-800">
                  <div className="text-center mb-4">
                    <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="fab fa-chrome text-3xl text-blue-600 dark:text-blue-400"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                      Chrome 商店安装
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      通过官方Chrome网上应用店安装
                    </p>
                  </div>
                  
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <i className="fas fa-check text-green-500 mr-2"></i>
                      <span>自动更新，安全可靠</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <i className="fas fa-check text-green-500 mr-2"></i>
                      <span>一键安装，简单快捷</span>
                    </div>
                    <div className="flex items-center text-sm text-amber-600 dark:text-amber-400">
                      <i className="fas fa-exclamation-triangle mr-2"></i>
                      <span>需要科学上网才能访问</span>
                    </div>
                  </div>
                  
                  <button
                    onClick={handleChromeStoreInstall}
                    className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl"
                  >
                    <i className="fab fa-chrome"></i>
                    <span>访问 Chrome 商店</span>
                    <i className="fas fa-external-link-alt text-sm"></i>
                  </button>
                </div>

                {/* 本地下载安装 - 右侧 */}
                                 <div className="border border-gray-200 dark:border-gray-700 rounded-xl p-4 md:p-6 hover:border-primary dark:hover:border-primary transition-all duration-300 hover:shadow-lg bg-gradient-to-br from-green-50/50 to-white dark:from-green-900/10 dark:to-gray-800">
                  <div className="text-center mb-4">
                    <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="fas fa-download text-3xl text-green-600 dark:text-green-400"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                      本地下载安装
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 text-sm">
                      下载安全的扩展源码包（.zip格式）
                    </p>
                  </div>
                  
                  <div className="space-y-2 mb-6">
                    <div className="flex items-start text-xs text-gray-600 dark:text-gray-400">
                      <span className="inline-block w-4 h-4 bg-green-600 text-white rounded-full text-center leading-4 mr-2 mt-0.5 flex-shrink-0 text-xs">1</span>
                      <span>下载并解压.zip文件到本地</span>
                    </div>
                    <div className="flex items-start text-xs text-gray-600 dark:text-gray-400">
                      <span className="inline-block w-4 h-4 bg-green-600 text-white rounded-full text-center leading-4 mr-2 mt-0.5 flex-shrink-0 text-xs">2</span>
                      <span>打开Chrome，进入 chrome://extensions/</span>
                    </div>
                    <div className="flex items-start text-xs text-gray-600 dark:text-gray-400">
                      <span className="inline-block w-4 h-4 bg-green-600 text-white rounded-full text-center leading-4 mr-2 mt-0.5 flex-shrink-0 text-xs">3</span>
                      <span>开启"开发者模式"</span>
                    </div>
                                         <div className="flex items-start text-xs text-gray-600 dark:text-gray-400">
                       <span className="inline-block w-4 h-4 bg-green-600 text-white rounded-full text-center leading-4 mr-2 mt-0.5 flex-shrink-0 text-xs">4</span>
                       <span>将解压后的文件夹拖入浏览器中</span>
                     </div>
                  </div>
                  
                  <button
                    onClick={handleLocalDownload}
                    className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl"
                  >
                    <i className="fas fa-download"></i>
                    <span>下载 .zip 扩展包</span>
                  </button>
                </div>
              </div>

              {/* 帮助提示 */}
              <div className="mt-6 bg-gradient-to-r from-primary/10 to-primary/5 dark:from-primary/20 dark:to-primary/10 border border-primary/20 dark:border-primary/30 rounded-lg p-4">
                <div className="flex items-start text-primary dark:text-primary-light">
                  <i className="fas fa-lightbulb mr-3 mt-0.5"></i>
                  <div className="text-sm">
                    <p className="font-medium mb-1">推荐选择</p>
                    <p className="text-gray-700 dark:text-gray-300">优先推荐Chrome商店安装，更加便捷。本地安装适合无法访问商店的用户，同样安全可靠。</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 弹框底部 */}
            <div className="bg-gray-50 dark:bg-gray-700 px-6 py-4">
              <button
                onClick={onClose}
                className="w-full px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 font-medium transition-colors"
              >
                稍后安装
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
      
      
    </AnimatePresence>
  );
};

export default ExtensionInstallModal; 